import { AbstractControl } from '@angular/forms';

export function NoSpaceOnlyValidation(control: AbstractControl) {
  const criteria = RegExp('[^ ]');
  return criteria.test(control.value) ? null : { required: true };
}
